export const CUSTOMER_SUPPORT = "Customer Support";
export const ADMIN = "admin";
export const SPONSOR = "sponsor";
export const PRINTER = "printer";
export const ADVISOR = "advisor";
export const INVESTOR = "investor";
